export default function SummaryCard({ title, onEdit, children }) {
  return (
    <section className="summary-card">
      <header className="summary-card-header">
        <h3 className="summary-card-title">{title}</h3>
        <button
          type="button"
          className="summary-card-edit"
          onClick={onEdit}
        >
          Edit
        </button>
      </header>
      <div className="summary-card-body">{children}</div>
    </section>
  )
}
